import { IEnumeration, EnumeratedSetValue } from 'utility-js-enumeration';
import { DeeplinkConfig, IDeeplinkStorageObjects, IDeeplinkConfigurationObject } from '../config/deeplink_config';
window['$ip'].require('@eab-pip/pi-navigation');

angular
  .module('capability-ng-deeplink')
  .controller(
    'DeeplinkController',
    function DeeplinkController(
      $state: ng.ui.IStateService,
      ngDeeplinkConfig: DeeplinkConfig,
      $stateParams: ng.ui.IStateParamsService
    ): void {
      const trackingInfo: string = ngDeeplinkConfig.hasTrackingInfo($stateParams);
      const stateEnum: EnumeratedSetValue | undefined = ngDeeplinkConfig.getDeeplinkEnum().get($stateParams.page);
      const defaultState: string = ngDeeplinkConfig.getDefaultState();
      const redirectedDueToAuthentication = window.location.href.indexOf('#/authentication') !== -1;

      ngDeeplinkConfig.setOriginalDeeplink('');
      if (!_.isEmpty(trackingInfo)) {
        ngDeeplinkConfig.trackLink(trackingInfo, stateEnum);
      }

      if (stateEnum) {
        const stateRequiredParams: any = (stateEnum as any).constructRouteParams($stateParams);
        const stateString: string = (stateEnum as any).getState($stateParams);
        const hrefString: string = (stateEnum as any).getHref();
        const navigation = window['$ip'].use('@eab-pip/pi-navigation');
        const hrefWithParams = navigation.uri.write(hrefString, stateRequiredParams);
        ngDeeplinkConfig.setOriginalDeeplink(window.location.href);

        if (hrefString) {
          ngDeeplinkConfig.storeHref(hrefWithParams);
          location.assign(hrefWithParams);
        } else if (stateString) {
          ngDeeplinkConfig.storeState({ state: stateString, stateParams: stateRequiredParams });
          $state.go(stateString, stateRequiredParams);
        }
      } else {
        $state.go(defaultState);
      }
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-deeplink/src/view/deeplink_controller.ts